"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var row_type_1 = require("../sis-tabular-report-rows-panel/model/row-type");
var table_row_type_1 = require("./table-row-type");
var row_option_1 = require("./row-option");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
/**
 * Created by pavel.arakelyan on 11/13/17.
 */
var RowView = /** @class */ (function () {
    function RowView(element) {
        this._showNew = false;
        this._prepareNew = false;
        this._isHidden = false;
        this._isDragging = false;
        this._isRemoved = false;
        this._isSelected = false;
        this._isBeforeRemoved = false;
        this._isGoingToRemove = false;
        this._isGoingToReplace = false;
        this._isParentRemoved = false;
        this._isRemovedParentCollapsed = false;
        this._drowDownShow = false;
        this._element = element;
        this._children = [];
        this._rowCategoryStyleDto = new idm_report_export_service_client_js_1.RowCategoryStyleDto();
    }
    Object.defineProperty(RowView.prototype, "rowType", {
        get: function () {
            return this._rowType;
        },
        set: function (value) {
            this._rowType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "element", {
        get: function () {
            return this._element;
        },
        set: function (value) {
            this._element = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "index", {
        get: function () {
            return this._index;
        },
        set: function (value) {
            this._index = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "children", {
        get: function () {
            return this._children;
        },
        set: function (value) {
            this._children = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (value) {
            this._parent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "showNew", {
        get: function () {
            return this._showNew;
        },
        set: function (value) {
            this._showNew = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "prepareNew", {
        get: function () {
            return this._prepareNew;
        },
        set: function (value) {
            this._prepareNew = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "collapsed", {
        get: function () {
            return this._collapsed;
        },
        set: function (value) {
            this._collapsed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "isHidden", {
        get: function () {
            return this._isHidden;
        },
        set: function (value) {
            this._isHidden = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "isDragging", {
        get: function () {
            return this._isDragging;
        },
        set: function (value) {
            this._isDragging = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "isRemoved", {
        get: function () {
            return this._isRemoved;
        },
        set: function (value) {
            this._isRemoved = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "isSelected", {
        get: function () {
            return this._isSelected;
        },
        set: function (value) {
            this._isSelected = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "isBeforeRemoved", {
        get: function () {
            return this._isBeforeRemoved;
        },
        set: function (value) {
            this._isBeforeRemoved = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "isGoingToRemove", {
        get: function () {
            return this._isGoingToRemove;
        },
        set: function (value) {
            this._isGoingToRemove = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "isGoingToReplace", {
        get: function () {
            return this._isGoingToReplace;
        },
        set: function (value) {
            this._isGoingToReplace = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "isParentRemoved", {
        get: function () {
            return this._isParentRemoved;
        },
        set: function (value) {
            this._isParentRemoved = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "isRemovedParentCollapsed", {
        get: function () {
            return this._isRemovedParentCollapsed;
        },
        set: function (value) {
            this._isRemovedParentCollapsed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "rowCategoryStyleDto", {
        get: function () {
            return this._rowCategoryStyleDto;
        },
        /**
         * ONLY FOR UNIT TESTING
         * @param {RowCategoryStyleDto} value
         */
        set: function (value) {
            this._rowCategoryStyleDto = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RowView.prototype, "drowDownShow", {
        get: function () {
            return this._drowDownShow;
        },
        set: function (value) {
            this._drowDownShow = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the id of the row recursively
     *
     * @param {RowsRootView} rowRoot
     * @returns {string}
     */
    RowView.prototype.getId = function (rowRoot) {
        var _this = this;
        var parentChildren = this._parent ? this._parent._children : rowRoot.rows;
        var parentId = (this._parent ? (this._parent.getId(rowRoot) + '-') : '');
        var id = parentChildren.findIndex(function (row) { return row === _this; });
        return parentId + id;
    };
    RowView.prototype.getMaxDepth = function () {
        var max = 0;
        if (this.children.length > 0) {
            this.children.forEach(function (rows) {
                if (!rows.isRemoved) {
                    if (rows.collapsed) {
                        max = (max === 0 ? 1 : max);
                    }
                    else if (rows.getMaxDepth() > max) {
                        max = rows.getMaxDepth();
                    }
                }
            });
            return max + 1;
        }
        else {
            return this.rowType === row_type_1.RowType.NEW ? 0 : 1;
        }
    };
    RowView.prototype.add = function (row) {
        row._parent = this;
        this._children.push(row);
    };
    RowView.prototype.remove = function (rowToRemove) {
        this._children.splice(this._children.findIndex(function (row) { return row === rowToRemove; }), 1);
    };
    RowView.prototype.getNewRow = function () {
        var lastChild = this._children[this._children.length - 1];
        return lastChild && lastChild.rowType === row_type_1.RowType.NEW ? lastChild : undefined;
    };
    /**
     * Removes New row from child rows (deactivates)
     */
    RowView.prototype.deActivateNewRow = function () {
        var indexToRemove = this._children.findIndex(function (row) { return row.rowType === row_type_1.RowType.NEW; });
        var newRowExists = indexToRemove !== -1;
        if (newRowExists) {
            this._children.splice(indexToRemove, 1);
        }
    };
    RowView.prototype.collapseRows = function (options) {
        this.setHiddenFlagsOnChildren();
        var fromIndex = this._index + 1;
        var toIndex = this.getLastNestedChildrenIndex();
        for (var index = fromIndex; index <= toIndex; index++) {
            if (options.get(index) && options.get(index).type === table_row_type_1.TableRowType.REMOVED) {
                continue;
            }
            if (!(options.get(index) && options.get(index).type === table_row_type_1.TableRowType.COLLAPSED)) {
                options.add(index, new row_option_1.RowOption(table_row_type_1.TableRowType.COLLAPSED, true));
            }
        }
    };
    RowView.prototype.expandRows = function (options) {
        this.cleanHiddenFlagsOnChildren();
        for (var i = 0; i < this._children.length; i++) {
            var index = this._children[i].index;
            if (options.get(index) && options.get(index).type === table_row_type_1.TableRowType.REMOVED) {
                continue;
            }
            options.add(index, new row_option_1.RowOption(table_row_type_1.TableRowType.EXPANDED, true));
            if (!this._children[i].collapsed) {
                this._children[i].expandRows(options);
            }
        }
    };
    RowView.prototype.removeRows = function (options) {
        // set removed flags to children
        this.setRemovedFlagsOnChildren();
        // set options to send header panel.
        var fromIndex = this._index + 1;
        var toIndex = this.getLastNestedChildrenIndex();
        for (var index = fromIndex; index <= toIndex; index++) {
            if (!(options.get(index) && options.get(index).type === table_row_type_1.TableRowType.REMOVED)) {
                if (options.get(index) && options.get(index).type === table_row_type_1.TableRowType.COLLAPSED) {
                    options.add(index, new row_option_1.RowOption(table_row_type_1.TableRowType.REMOVED, false));
                }
                else {
                    options.add(index, new row_option_1.RowOption(table_row_type_1.TableRowType.REMOVED, true));
                }
            }
        }
    };
    RowView.prototype.removeRow = function (rowsRoot, isCollapsed) {
        var _this = this;
        // shift children to parent level
        var parentChildren = this._parent ? this._parent._children : rowsRoot.rows;
        var index = parentChildren.findIndex(function (row) { return row._index === _this._index; });
        if (this._parent) {
            this._parent.children = [];
            for (var i = 0; i < parentChildren.length; i++) {
                this._parent.add(parentChildren[i]);
                if (i === index) {
                    this.children.forEach(function (value) {
                        value.isParentRemoved = true;
                        value.isRemovedParentCollapsed = isCollapsed;
                        _this._parent.add(value);
                    });
                    this._children = [];
                }
            }
        }
        else {
            rowsRoot.rows = [];
            for (var i = 0; i < parentChildren.length; i++) {
                rowsRoot.add(parentChildren[i]);
                if (i === index) {
                    this.children.forEach(function (value) {
                        value.isParentRemoved = true;
                        value.isRemovedParentCollapsed = isCollapsed;
                        rowsRoot.add(value);
                    });
                    this._children = [];
                }
            }
        }
        rowsRoot.setIndexes();
    };
    RowView.prototype.setHiddenFlagsOnChildren = function () {
        this.children.forEach(function (value) {
            value.isHidden = true;
            value.setHiddenFlagsOnChildren();
        });
    };
    RowView.prototype.cleanHiddenFlagsOnChildren = function () {
        this.children.forEach(function (value) {
            value.isHidden = false;
            if (!value.collapsed) {
                value.cleanHiddenFlagsOnChildren();
            }
        });
    };
    RowView.prototype.setRemovedFlagsOnChildren = function () {
        this.children.forEach(function (value) {
            value.isRemoved = true;
            value.setRemovedFlagsOnChildren();
        });
    };
    RowView.prototype.getLastNestedChildrenIndex = function () {
        if (this._children.length > 0) {
            return this._children[this._children.length - 1].getLastNestedChildrenIndex();
        }
        return this.index;
    };
    RowView.prototype.setHighlightRemoveFlags = function (options) {
        this.children.forEach(function (value) {
            value.isGoingToRemove = true;
            options.add(value.index, new row_option_1.RowOption(table_row_type_1.TableRowType.HIGHLIGHT_REMOVE, true));
            value.setHighlightRemoveFlags(options);
        });
    };
    RowView.prototype.getUsedCategoryPathIdsInBranch = function () {
        var pathIds = [];
        if (this.element) {
            pathIds.push(this.element.categoryElementDto.categoryPathHolderId);
        }
        for (var i = 0; i < this.children.length; i++) {
            var branchPathIds = this.children[i].getUsedCategoryPathIdsInBranch();
            branchPathIds.forEach(function (pathId) {
                pathIds.push(pathId);
            });
        }
        return pathIds;
    };
    return RowView;
}());
exports.RowView = RowView;
//# sourceMappingURL=row-view.model.js.map